/* @flow */

import type { Point } from './Common';
import { ParticleVerticalMaxSpeed } from './Common';
import LineSegment from './LineSegment';

export default class Surface {
  centerPosition: Point;
  radians: number;
  hypotenuse: number;
  lineSegment: LineSegment;
  leftPoint: Point;
  rightPoint: Point;
  walkable = true;
  bouncy = true;

  constructor(centerPosition: Point, radians: number, hypotenuse: number) {
    this.lineSegment = new LineSegment();
    this.radians = radians;
    this.hypotenuse = hypotenuse;
    this.setCenterPosition(centerPosition);
  }

  setCenterPosition(centerPosition: Point) {
    this.centerPosition = { ...centerPosition };
    this.calculatePoints();
  }

  getSlope() {
    const { radians, hypotenuse } = this;
    let width = Math.cos(radians) * hypotenuse;
    let height = Math.sin(radians) * hypotenuse;
    return {
      width,
      height,
      slope: height / width,
    };
  }

  calculatePoints() {
    const { centerPosition } = this;
    const { width, height } = this.getSlope();
    this.leftPoint = {
      x: centerPosition.x - width / 2,
      y: centerPosition.y - height / 2,
    };
    this.rightPoint = {
      x: centerPosition.x + width / 2,
      y: centerPosition.y + height / 2,
    };
    this.lineSegment.setFromTo(this.leftPoint, this.rightPoint);
  }

  isStandingOn(lastPosition: Point, currPosition: Point) {
    const { walkable, leftPoint, rightPoint } = this;
    if (!walkable) {
      return null;
    }

    const { slope } = this.getSlope();

    const lastSurfaceY = leftPoint.y + slope * (lastPosition.x - leftPoint.x);
    const currSurfaceY = leftPoint.y + slope * (currPosition.x - leftPoint.x);

    const wiggleRoom = this.hypotenuse / 10;
    const withinHorizontal =
      leftPoint.x - wiggleRoom <= lastPosition.x &&
      lastPosition.x <= rightPoint.x + wiggleRoom &&
      leftPoint.x - wiggleRoom <= currPosition.x &&
      currPosition.x <= rightPoint.x + wiggleRoom;
    const lastAbove = lastSurfaceY <= lastPosition.y;
    const currBelow = currPosition.y <= currSurfaceY;

    return withinHorizontal && lastAbove && currBelow ? currSurfaceY : null;
  }

  toggleBounce() {
    this.bouncy = !this.bouncy;
  }
  bounce(speed: Point) {
    const { bouncy } = this;
    const { slope } = this.getSlope();
    if (bouncy) {
      return {
        x: (speed.y * 1.5) / slope,
        // always bounce up
        y: Math.abs(speed.x),
      };
    } else {
      const dx = slope > 0 ? -1 : 1;
      return {
        x: (dx * ParticleVerticalMaxSpeed) / 5,
        // always bounce up
        y: Math.abs(speed.x),
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/Surface.js